import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

import { subscribeToNewsletter } from '../../actions/content';

import TextField from '../../components/TextField';
import Button from '../../components/Button';
import CheckboxField from '../../components/CheckboxField';

export default class NewsletterCTA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      hiphop: false,
      indie: false,
      pop: false,
      electronic: false,
      subscribed: false,
    };

    this.setValue = this.updateField.bind(this);
  }

  updateField(key, value) {
    this.setState({
      [key]: value,
    });
  }

  signup() {
    this.setState({
      subscribed: true,
    });
    this.props.dispatch(subscribeToNewsletter(this.state));
  }

  render() {
    return this.state.subscribed ? (
      <div className={css(styles.container)}>
        <div className={css(styles.title)}>We'll keep that nose fresh with the latest music delivered to your inbox.</div>
      </div>
    ) : (
      <div className={css(styles.container)}>
        <div className={css(styles.title)}>Keep in the know! Sign up to our Newsletter.</div>
        <div className={css(styles.form_group)}>
          <CheckboxField
            id="hiphop"
            name="hiphop"
            label="Hip Hop"
            fullWidth
            handler={this.setValue}
            value={this.state.hiphop}
          />
          <CheckboxField
            id="indie"
            name="indie"
            label="Indie"
            fullWidth
            handler={this.setValue}
            value={this.state.indie}
          />
          <CheckboxField
            id="pop"
            name="pop"
            label="Pop"
            fullWidth
            handler={this.setValue}
            value={this.state.pop}
          />
          <CheckboxField
            id="electronic"
            name="electronic"
            label="Electronic"
            fullWidth
            handler={this.setValue}
            value={this.state.electronic}
          />
        </div>
        <div className={css(styles.form)}>
          <TextField fullWith placeholder="Enter your email address" name="email" handler={this.setValue} value={this.state.email} />
          <div className={css(styles.button_container)}>
            <Button handler={this.signup.bind(this)} title="Sign up" />
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Theme.white,
    height: 250,
    marginTop: 50,
    [Theme.mobile_query]: {
      display: 'none',
    },
  },
  title: {
    fontFamily: Theme.fontFamily_secondary,
    fontWeight: '300',
    fontSize: 17,
    color: Theme.black,
    marginBottom: 20,
  },
  form_group: {
    display: 'flex',
    flexDirection: 'row',
    margin: '10px 0px 20px',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'row',
    width: 500,
    justifyContent: 'center',
  },
  button_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    height: 50,
    marginLeft: -5,
  },
});



// WEBPACK FOOTER //
// ./src/components/NewsletterCTA/index.js